import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import { Video, Clock, CalendarDays, ArrowUpRight } from "lucide-react";

const details = [
  { icon: CalendarDays, label: "Every week", value: "Mon · Wed · Fri" },
  { icon: Clock, label: "Just 20 minutes", value: "8:00am start" },
  { icon: Video, label: "Live on Zoom", value: "From anywhere" },
];

export default function GroupClasses() {
  return (
    <section id="group-classes" data-testid="group-classes-section" className="relative py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative overflow-hidden rounded-[14px] bg-plum text-cream"
        >
          <div className="pointer-events-none absolute -top-24 -right-16 h-80 w-80 rounded-full bg-mne-pink/25 blur-[110px]" />
          <div className="pointer-events-none absolute -bottom-24 -left-16 h-80 w-80 rounded-full bg-mne-blue/20 blur-[110px]" />

          <div className="relative grid lg:grid-cols-12 gap-10 p-8 md:p-14 lg:p-16 items-center">
            {/* left copy */}
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 rounded-full bg-cream/10 px-4 py-2 text-[11px] uppercase tracking-[0.24em] text-mne-pink">
                <span className="h-1.5 w-1.5 rounded-full bg-mne-pink animate-pulse" /> New · Online Offer
              </span>

              <h2 className="mt-6 font-serif font-light text-4xl md:text-6xl leading-[1.02]">
                Live Group Fitness,
                <span className="italic text-mne-pink"> straight to your living room.</span>
              </h2>

              <p className="mt-6 max-w-lg text-base md:text-lg text-cream/75 leading-relaxed">
                Join Jennie-Marie for energising 20-minute group workouts over Zoom — designed for
                women 40+ to build strength and start the day feeling unstoppable. No gym, no
                pressure, just you and a supportive community.
              </p>

              <div className="mt-8 grid sm:grid-cols-3 gap-4">
                {details.map((d) => {
                  const Icon = d.icon;
                  return (
                    <div key={d.label} data-testid={`class-detail-${d.label.toLowerCase().replace(/\s+/g, '-')}`} className="rounded-[8px] border border-cream/15 bg-cream/[0.04] p-4">
                      <Icon size={20} className="text-mne-pink" strokeWidth={1.6} />
                      <p className="mt-3 text-cream font-medium text-[15px]">{d.value}</p>
                      <p className="text-[11px] uppercase tracking-[0.14em] text-cream/50 mt-1">{d.label}</p>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* right price card */}
            <div className="lg:col-span-5 lg:pl-6">
              <div className="rounded-[12px] bg-cream text-plum p-8 md:p-10 text-center shadow-[0_30px_80px_-30px_rgba(0,0,0,0.5)]">
                <p className="text-[11px] uppercase tracking-[0.24em] text-stone">Membership</p>
                <div data-testid="class-price" className="mt-4 flex items-end justify-center gap-1">
                  <span className="font-serif text-7xl md:text-8xl leading-none text-plum">£29</span>
                  <span className="mb-3 text-stone text-lg">/month</span>
                </div>
                <p className="mt-3 text-stone text-[15px]">3 live classes every week · cancel anytime</p>

                <button
                  data-testid="class-join-cta"
                  onClick={() => {
                    window.dispatchEvent(new CustomEvent("preselect-service", { detail: "Online Group Fitness" }));
                    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="group mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-plum px-8 py-4 text-[12px] uppercase tracking-[0.18em] text-cream transition-colors duration-300 hover:bg-plum-deep"
                >
                  Join the Classes
                  <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </button>
                <p className="mt-4 text-[12px] text-stone">Spaces are limited — reserve yours today.</p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
